<template>
	<div class="intro">
		<StateButtons />
	</div>
</template>

<script>
import StateButtons from '@/components/main/StateButtons'
import session from '@/mixins/session'

export default {
	name: 'Intro',
	mixins: [session],
	components: {
		StateButtons
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.intro {
	@include corridor;
	margin-top: 2rem;
	margin-bottom: 2rem;

	@include mq(lg) {
		margin-top: 4rem;
		margin-bottom: 4rem;
	}
}
</style>
